import { render, staticRenderFns } from "./StopPD_Details.vue?vue&type=template&id=622aa93f"
import script from "./StopPD_Details.vue?vue&type=script&lang=js"
export * from "./StopPD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports